import React, { useState } from 'react';
import { useSecuritySettings } from '../../hooks/useAuditLog';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { LoginHistoryTable } from '../../components/security/LoginHistoryTable';
import { LogIn } from 'lucide-react';

type StatusFilter = 'ALL' | 'SUCCESS' | 'FAILED';

export const LoginHistoryPage: React.FC = () => {
  const { loginHistory, isLoading } = useSecuritySettings();
  const [statusFilter, setStatusFilter] = useState<StatusFilter>('ALL');

  const filtered = loginHistory.filter(entry =>
    statusFilter === 'ALL' ? true : entry.status === statusFilter
  );

  const failedCount = loginHistory.filter(h => h.status === 'FAILED').length;

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-slate-100 flex items-center gap-2">
          <LogIn className="w-5 h-5 text-sky-400" />
          Login History
        </h3>
        <p className="text-xs text-slate-400">
          Authentication attempts and security events Â· <span className="text-rose-400">{failedCount} failed</span>
        </p>
      </div>

      <Card>
        <div className="flex items-center gap-2 mb-4">
          {(['ALL', 'SUCCESS', 'FAILED'] as StatusFilter[]).map(s => (
            <Button
              key={s}
              size="sm"
              variant={statusFilter === s ? 'primary' : 'outline'}
              onClick={() => setStatusFilter(s)}
            >
              {s === 'ALL' ? 'All' : s === 'SUCCESS' ? 'Successful' : 'Failed'}
            </Button>
          ))}
        </div>

        <LoginHistoryTable history={filtered} isLoading={isLoading} />
      </Card>
    </div>
  );
};
